import Chart from './components/Chart/index.js';
import configuration from './configuration.js';
import translations from './translations/index.js';

export default {
  configuration,
  translations,
  Chart
};

export {
  configuration,
  translations,
  Chart
};
